<template>
  <div class="projectlist">
    <div class="pro">
      <div class="newlist">
        <ul class="list2">
          <li v-for="(item, index) in projectList" :key="index">
            <div class="li_l2" @click="goInfo(item.id)">
              <div class="li_title">{{ item.title }}</div>
              <div class="li_dec">{{ item.describe }}</div>
              <div class="li_tag">
                <span v-for="(item2, index2) in item.cate_name" :key="index2"
                  >#{{ item2 }}</span
                >
              </div>
            </div>
            <span class="delB" @click="delPro(item.id, index)">删除</span>
            <!--   <img
              class="delPro"
              src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_pdel.png"
              @click="delPro(item.id, index)"
            /> -->
          </li>
        </ul>
      </div>
    </div>
    <div class="nodata" v-if="nodata">
      <div style="height: 2.5rem;"></div>
      <img
        src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_nodata.png"
      />
      <p>暂无内容</p>
    </div>
    <div class="fabuBtn1">
      <router-link :to="{ path: '/project/index' }">发布招商项目</router-link>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getShare, getProjectListNew, getDelProjectNew } from "@api/public";
import { cookie } from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
let vm = null;
export default {
  name: "projectList",
  components: {},
  props: {},
  data: function() {
    return {
      nodata: false,
      projectList: [],
    };
  },
  created() {
    vm = this;
  },
  watch: {},
  mounted: function() {
    vm.setOpenShare();
    vm.getProjectListNew();
  },
  methods: {
    // 获取项目列表
    getProjectListNew() {
      getProjectListNew().then((res) => {
        if (res.data.length == 0) {
          this.nodata = true;
        } else {
          this.projectList = res.data;
        }
      });
    },
    goInfo(id) {
      window.location.href = "/project/info?projectid=" + id;
    },
    delPro(id, index) {
      getDelProjectNew({
        project_id: id,
      }).then((res) => {
        this.projectList.splice(index, 1);
        return Toast(res.msg);
      });
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then((res) => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: "https://jiaojiao.yanjiusuo.xyz",
            imgUrl: data.img,
          };
          openShareAll(configAppMessage);
        });
      }
    },
  },
};
</script>

<style scoped="scoped">
body,
html {
  background-color: #f4f4f4 !important;
}

.nodata {
  width: 100%;
  text-align: center;
}

.nodata img {
  display: block;
  width: 4rem;
  margin: 0 auto;
}

.nodata p {
  font-size: 0.3rem;
  margin-top: 0.02rem auto 0;
  color: #999;
  text-align: center;
}

.list2 {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.list2 li {
  box-shadow: 0 0 0.1rem #e2e2e2;
  padding: 0.3rem;
  border: none;
  position: relative;
  width: 6.9rem;
  margin: 0.15rem auto 0;
  background: #fff;
}

.li_l2 {
  width: 100%;
  margin: 0 auto 0.12rem;
}

.li_l2 .li_title {
  font-size: 0.34rem;
  color: #000;
  width: 83% !important;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.li_l2 .li_dec {
  font-size: 0.28rem;
  color: #333;
  margin-top: 0.2rem;
  margin-bottom: 0.4rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.li_l2 .li_tag {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  position: relative;
  font-size: 0.22rem;
  color: #999;
}

.li_l2 .li_tag span {
  margin-right: 0.12rem;
  font-size: 0.26rem !important;
  color: #999 !important;
  border: none !important;
}

.delB {
  position: absolute;
  right: 0;
  top: 0;
  color: #ff410a;
  font-size: 0.28rem;
  background: #ffece6;
  width: 1.23rem;
  text-align: center;
  line-height: 0.56rem;
  border-radius: 0 0 0 0.1rem;
}

.fabuBtn1 {
  width: 90%;
  margin: 0.6rem auto 0;
  border-radius: 0.16rem;
  text-align: center;
  line-height: 0.85rem;
  background-color: #ff410a;
  font-size: 0.32rem;
  color: #fff;
  color: #fff;
}

.fabuBtn1 a {
  color: #ffffff;
}
</style>
